import { gql } from '@apollo/client';

const TACTICAL_OFFERS_SCHEMA = `
serviceGroup
heading
copy
mobileImage {
  imageURL
  imageAtlText
}
desktopImage{
  imageURL
  imageAtlText
}
`;

const QUERIES = {
  GET_TACTICAL_OFFERS: gql`
      query getTacticalOffers(
        $serviceGroupCode: String!
      ) {
        getTacticalOffers(
            serviceGroupCode: $serviceGroupCode
        ) {
          ${TACTICAL_OFFERS_SCHEMA}
        }
      }
    `,
};

// to get Tactical offers
const getTacticalOffers = async ({ graphql, variables = {} }) => {
  const { data } = await graphql.query({
    query: QUERIES.GET_TACTICAL_OFFERS,
    variables,
  });
  return data.getTacticalOffers;
};

export default getTacticalOffers;
